import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContentCollectionAccountInformation, ContentCollectionPageHeader, ContentCollectionWorkspaceInformation } from "@air/feature-content-collection/ui";
import { Air } from "@air/next-icons";
import Link from "next/link";
import { PublicSignUpButton } from "~/components/PublicSignUpButton";
import { Routes } from "~/constants/routes";
import { BOARD_COLLECTION_HERO, PUBLIC_TOP_BAR_LOGO } from "~/constants/testIDs";
export const BoardCollectionHero = (param)=>{
    let { workspace, account } = param;
    return /*#__PURE__*/ _jsxs(ContentCollectionPageHeader, {
        "data-testid": BOARD_COLLECTION_HERO,
        children: [
            /*#__PURE__*/ _jsx(ContentCollectionWorkspaceInformation, {
                workspace: workspace
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-3",
                children: [
                    account ? /*#__PURE__*/ _jsx(ContentCollectionAccountInformation, {
                        account: account
                    }) : /*#__PURE__*/ _jsx(PublicSignUpButton, {}),
                    /*#__PURE__*/ _jsx(Link, {
                        href: Routes.root,
                        children: /*#__PURE__*/ _jsx(Air, {
                            className: "w-12 text-blue-9",
                            "data-testid": PUBLIC_TOP_BAR_LOGO
                        })
                    })
                ]
            })
        ]
    });
};
